import { apiURL } from '../URLs'
import { account } from '../../classes/Account'
import { getStoredSessionId } from './sessionStorage'

function canTrack() {
  return Boolean(account.accessToken)
}

async function postTrack(payload) {
  if (!canTrack()) return

  const body = JSON.stringify({
    ...payload,
    sessionId: getStoredSessionId() || undefined
  })

  try {
    await fetch(`${apiURL}/api/activity/track`, {
      method: 'POST',
      headers: {
        'Authorization': account.accessToken,
        'Content-Type': 'application/json',
        'x-session-id': getStoredSessionId()
      },
      body,
      keepalive: true,
      credentials: 'include'
    })
  } catch {
    // best-effort
  }
}

export function trackPageview(path) {
  postTrack({
    eventType: 'pageview',
    eventName: 'pageview',
    path: path || (typeof window !== 'undefined' ? window.location.pathname : '')
  })
}

export function trackAction(eventName, { applicationId, targetId, metadata, path } = {}) {
  postTrack({
    eventType: 'action',
    eventName,
    path: path || (typeof window !== 'undefined' ? window.location.pathname : ''),
    applicationId,
    targetId,
    metadata
  })
}
